    import axiosAuth from '../../../shared/configs/axios-auth'

    const getDefaultState = () => {
        return {
           notificationSent: null
        }
    }
    
    const state = getDefaultState()

    const getters = {
        notificationSent: state => {
            return state.notificationSent
        },
    }

    const mutations = {
        resetState (state) {
            Object.assign(state, getDefaultState())
        },
        notificationSent: (state, payload) => {
            state.notificationSent = payload
        },
    }

    const actions = {
       
        postNotification ({commit}, payload) {
            commit('updating', true)
            commit('notificationSent', null)
            axiosAuth.post('/notifications', payload)
                .then(
                    res => {
                        commit('notificationSent', true)
                        commit('trash', res)
                        commit('updating', false)
                    }
                )
                .catch(
                error => {
                    commit('notificationSent', false)
                    console.log(error.response)
                    commit('updating', false)
                }
                )
        },

     
    }

    export default {
        state,
        getters,
        mutations,
        actions
    }